export default __webpack_public_path__ + "static/media/atc-tease.2a455d2d.gif";